/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LastInspectionFilterDto { 
    buildingId?: string;
    tenantId: string;
    searchText?: string;
    inspectionType?: LastInspectionFilterDto.InspectionTypeEnum;
}
export namespace LastInspectionFilterDto {
    export type InspectionTypeEnum = 'REGULAR' | 'SCHADSTELLENPLAN';
    export const InspectionTypeEnum = {
        Regular: 'REGULAR' as InspectionTypeEnum,
        Schadstellenplan: 'SCHADSTELLENPLAN' as InspectionTypeEnum
    };
}


